(function() {
    'use strict';
 
 		
a3_pilot_reports.controller('ReportCtrl', ReportCtrl);
    
    /**
    * @memberof PilotReports
    * @ngdoc controller
    * @name ReportCtrl
    * @description 
    *  Manages the Report View
    * @ngInject
    */
    function ReportCtrl($scope, $routeParams, UserFactory, AircaftPositionsFactory,FlightFactory,PilotReportLocalEditFactory,
		PilotReportLocalEditCreatorFactory,$location,SettingsMain,$timeout,ReportGuidFactory,$route,
		aircraftLateArrivalReportId,inadequateGroundTimeReportId , FlightDelaysFactory,
		autolandSupportingAcTypes,  showCatIIApprachAcTypes) {

		$scope.discard = discard;
		$scope.infoSaveOperation = infoSaveOperation;
		$scope.setCategory = setCategory;
		$scope.state = 'report'
		$scope.deleteReportClicked = deleteReportClicked;
		$scope.autoAdjustTarget = null;
		$scope.autoAdjustTimer = null;
		$scope.autoAdjustRun = autoAdjustRun;
		$scope.saveDraftClicked = saveDraftClicked;
		$scope.saveClicked = saveClicked;
		$scope.cancelClicked = cancelClicked;
		$scope.reportItemValueChanged = reportItemValueChanged;
		$scope.adjustTextarea = adjustTextarea;	
		$scope.clearRemarks = clearRemarks;
		$scope.reportChanged = reportChanged;
        $scope.AutolandChanged = AutolandChanged;
        $scope.CatApproachChanged = CatApproachChanged;
		$scope.AutolandReasonChanged = AutolandReasonChanged;
		$scope.updateAutolandStatus = updateAutolandStatus; 
		$scope.CatAutolandReasonChanged = CatAutolandReasonChanged;
		$scope.updateCatAutolandStatus = updateCatAutolandStatus;

		$scope.isValidWorkOrderNo = false;
		$scope.workOrderNo = null;
		$scope.validationWorkOrderNo = validationWorkOrderNo;
		$scope.autoGetDelaysInItems = autoGetDelaysInItems;
		$scope.autoGetDelaysIsExecuted = false;
		$scope.enableAutofillDelaysButton = false;
		$scope.flightDelays = null;
		$scope.sumReportedDelay = null;

		$scope.plusNumber = plusNumber;
		$scope.minusNumber = minusNumber;
		$scope.clearNumber = clearNumber;

		$scope.clearACUProvisionRemarks = clearACUProvisionRemarks;
		$scope.updateACUProvisionValue = updateACUProvisionValue;
		$scope.updateACUProvisionRemarks =  updateACUProvisionRemarks;
		$scope.plusACUMinutes = plusACUMinutes;
		$scope.minusACUMinutes = minusACUMinutes;
		$scope.clearACUMinutes = clearACUMinutes;
		

		$scope.logIt = logIt;

		function logIt(x){

			console.log("User = " + JSON.stringify(x));

		}

         
		// get the report id
		var reportId = $routeParams.reportId;
		var report = null;

		// show logged user info
		var user = UserFactory.getUser();
		$scope.logged_user_info = user.aimsId + ' - ' + user.name;
		$scope.isSecure = UserFactory.isSecure();
		
		// new / edit existing / load from temp
		if (reportId.startsWith('new:')) {

			// get the flight id
			var flightAimsId = reportId.substring(4, reportId.length);
			var flightId = $routeParams.flightId;

			// create a new report
			var newLocalReport = PilotReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId,flightAimsId);
			
			if (newLocalReport == null) {
				bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.", 
					function() {
						$location.path("/");
						$scope.$apply();
					}
				);
				return;
			}
			else {
				
				// load the new report
				report = newLocalReport;
			}
		}
		else if (reportId == 'temp') {
			
			// load the report from the temp place
			report = PilotReportLocalEditFactory.getPilotReportLocalEditFromTemp();
			
			if (report == null) {
				
				// since we could not load the temp report, delete it
				PilotReportLocalEditFactory.deleteTempReport();

				bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device", 
					function() {
						$location.path("/");
						$scope.$apply();
					}
				);
				return;
			}
		}
		else {
			
			// load the report
			report = PilotReportLocalEditFactory.getPilotReportLocalEdit(reportId);
			
			if (report == null) {
				bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.", 
					function() {
						$location.path("/");
						$scope.$apply();
					}
				);
				return;
			}
		}

		//flight
        var flight = FlightFactory.getFlightFromTotalFlights(report.FlightId);
		
		//Get flight delays
		$scope.flightDelays = FlightDelaysFactory.getFlightDelaysByFlightId(report.FlightId);

		if($scope.flightDelays){
			//Update scope for the visibility autofill delays button
			checkAutofillDelaysButton();
			updateSumValueOfReportedDelays();
		}

        if(!flight){
			// go to dashboard if no flight
			$location.path("/");
		}
         
		$scope.showAutolandSection = autolandSupportingAcTypes.includes(flight.AcType);
		$scope.showCatIIApprachSection = showCatIIApprachAcTypes.includes(flight.AcType);
         
/*       //find late arrival report item and fill it with previous Late Aircraft Arrival
        var lateArrivalreportItem = null; 
        report.Sections.forEach(
            function(section){
                var filteredItems = section.Items.filter(
                    function(item){
                        return item.Id == aircraftLateArrivalReportId
                    });
                if(filteredItems.length==1){
                    lateArrivalreportItem = filteredItems[0];
                }
            }
        );
        
        var inadequateGroundTimeReportItem = null; 
        report.Sections.forEach(
            function(section){
                var filteredItems = section.Items.filter(
                    function(item){
                        return item.Id == inadequateGroundTimeReportId
                    });
                if(filteredItems.length==1){
                    inadequateGroundTimeReportItem = filteredItems[0];
                }
            }
        );*/
        
/*        var aircaftPositions =  AircaftPositionsFactory.getAircaftPositionsByFlightId(flight.FlightId);
        if(aircaftPositions && aircaftPositions.PreviousSTA && !$scope.isTurboProp){
            var startofTAT = moment.utc(flight.ScheduledDeparture).add(-45, 'm');
            var prevATA = moment.utc(aircaftPositions.PreviousATA);
            var prevSTA = moment.utc(aircaftPositions.PreviousSTA);
            var lateArrival = 0;
            var inadequateGroundTime = 0;
                if(startofTAT.diff(prevSTA, 'm')>=0 && aircaftPositions.PreviousATA){
              
                    var comparedValue = startofTAT;
                    if(lateArrival > 0){
                        var comparedValue = prevATA;
                    }
                    lateArrival = prevATA.diff(comparedValue, 'm');
                }else{
                    lateArrival = aircaftPositions.PreviousATA ? prevATA.diff(prevSTA, 'm') : 0;
                    inadequateGroundTime = prevSTA.diff(startofTAT, 'm');
                    if(lateArrival<0){
                        inadequateGroundTime = inadequateGroundTime + lateArrival;
                    }
                }
            
            if(lateArrival>0 && lateArrivalreportItem && !lateArrivalreportItem.ItemHasValue){
                lateArrivalreportItem.ItemValue = "Late Aircraft Arrival " + lateArrival + " minutes";
                lateArrivalreportItem.ItemHasValue= true;
            }
            
            if(inadequateGroundTime>0 && inadequateGroundTimeReportItem && !inadequateGroundTimeReportItem.ItemHasValue){
                inadequateGroundTimeReportItem.ItemValue = "Inadequate Ground Time " + inadequateGroundTime + " minutes";
                inadequateGroundTimeReportItem.ItemHasValue= true;
            }
        }
        */
       
        
		$scope.flight =  flight;
	 	$scope.panels = {
			delays: { open:true },
			showOnlyOne: true,
			report: {
				visible: true,
				open: true,
				cssClass: function() {
					return report.IsValid ? 'panel-green' : 'panel-orange';
				}
			},
            autoland: {
				open: (report.AutolandSatisfactory || report.AutolandUnsatisfactory)
			},
            
            catApproach: {
				open: (report.catApproachSatisfactory || report.catApproachUnsatisfactory)
			},
			 Flight: {
				visible: true,
				open: false,
				cssClass: function(report) {
					if (report.WarningItems > 0)
						return 'panel-orange';
					else if (report.ActiveItems > 0)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			groundServices: {
				visible: true,
				open: false,
				cssClass: function() {
					if (report.GroundServicesSectionHasValue)
						return 'panel-green';
					else
						return 'panel-default';
				}
			},
			acuProvision: { 
				visible: true,
				open: false,
				cssClass: function() {
					if (report.ACUProvision.isValid)
						return 'panel-green';
					else if(report.ACUProvision.isRequired && !report.ACUProvision.isValid){
						return 'panel-orange';
					}
					else
						return 'panel-default';
				}
			}
		};

		$scope.GetCategoryCSS = GetCategoryCSS;

		function GetCategoryCSS(items, category){
			
			var itemsInCategory = items.filter(function(item) {
				return item.CategoryLabel == category;
			});
			var completed = itemsInCategory.some(function(item) {
				return item.ItemHasValue == true && item.ItemValue && item.ItemValue.length > 0;
			});
			var draft = itemsInCategory.some(function(item) {
				return item.ItemHasValue == true && (!item.ItemValue || item.ItemValue == "");
			});
			if (draft)
				return 'panel-orange';
			else if (completed)
				return 'panel-green';
			else
				return 'panel-gray';
		}
		
		
		$scope.countDHC = 0;
		if (report.crew) $scope.countDHC = report.crew.filter(function(item){return (item.isDHC==true);}).length;
			 
		if(report && report.ScheduledArrival){
			var nowTimeStamp = new Date().getTime();
			var schedullDepartureTimestamp = new Date(report.ScheduledArrival).getTime();

			$scope.isFuture = nowTimeStamp<schedullDepartureTimestamp;
		}
        
        $scope.showCompleted = showCompleted;
        $scope.showAll = showAll;
        $scope.compressedMode = false;
        function showCompleted(){
            $scope.panels.report.open =!$scope.panels.report.open;
             $scope.compressedMode = true;
        }
    
            
        function showAll(){
            $scope.panels.report.open =!$scope.panels.report.open;
            $scope.compressedMode = false;
        }
    
        
			 
		// update totals and set to scope
		report.updateTotals();
		$scope.report = report;
		var categoryFilter = null;
		var categoryFilters = [];

		for (var i=0;i<report.Sections.length;i++){
			categoryFilter={category:'',section : report.Sections[i].Label} ;
			categoryFilters.push(categoryFilter);
		}

		$scope.categoryfilters = categoryFilters;
			 
		// save the report to a temp place
		if (report.Status != 'synched')
			report.saveReportAsTemp();
		
		// set editing page to report
		SettingsMain.setEditingPage('report');
        
        /**
         * When report changes run to update the item
         * @memberof ReportCtrl
         */
		function reportChanged(item) {
			// put preset comments
			if (item != null) {
				if (item.PresetComments != null) {
					if ((item.ItemValue == null) || (item.ItemValue == '')) {
						item.ItemValue = item.PresetComments;
					}
				}
			}
			
			updateSumValueOfReportedDelays();

			// update the report totals
			report.updateTotals();
			
			// save the report to a temp place
			if (report.Status != 'synched')
				report.saveReportAsTemp();
		}
		
        
        
        function AutolandChanged(result){
            if(result == true && report.AutolandSatisfactory){
               report.AutolandUnsatisfactory =  false;
			   report.ManualLanding = false;
            }else if(result == false && report.AutolandUnsatisfactory){
                report.AutolandSatisfactory  = false;
				report.ManualLanding = false;
            }else if(result == "manual" && report.ManualLanding){
				report.AutolandUnsatisfactory =  false;
				report.AutolandSatisfactory = false;
			}
            
            reportChanged()
        }
        
           
        function CatApproachChanged(result){
            if(result == true &&  report.catApproachSatisfactory){
               report.catApproachUnsatisfactory =  false;
			   report.ManualLanding = false;
            }else if(result == false &&  report.catApproachUnsatisfactory){
                report.catApproachSatisfactory  = false;
				report.ManualLanding = false;
            }else if(result == "manual" && report.ManualLanding){
				report.catApproachUnsatisfactory =  false;
				report.catApproachSatisfactory = false;
			}
            
            reportChanged()
        }
        
		function AutolandReasonChanged(result) {
			if (result == true) {
				report.AutolandReasonIsPractice = false;
				report.AutolandSatisfactory = false;
				report.AutolandUnsatisfactory = false;
				report.ManualLanding = false;
				report.AutolandWorkOrderNo = "";
				report.ManualLandingComments = "";
			} else if (result == false) {
				report.AutolandReasonIsLowVisibility = false;
				report.AutolandSatisfactory = false;
				report.AutolandUnsatisfactory = false;
				report.ManualLanding = false;
				report.AutolandWorkOrderNo = "";
				report.ManualLandingComments = "";
			}
			reportChanged()
		}

		function CatAutolandReasonChanged(result) {
			if (result == true) {
				report.AutolandReasonIsPractice = false;
				report.catApproachUnsatisfactory = false;
				report.catApproachSatisfactory = false;
				report.ManualLanding = false;
				report.ManualLandingComments = "";
			} else if (result == false) {
				report.AutolandReasonIsLowVisibility = false;
				report.catApproachUnsatisfactory = false;
				report.catApproachSatisfactory = false;
				report.ManualLanding = false;
				report.ManualLandingComments = "";
			}
			reportChanged()
		}

		function updateAutolandStatus() {
			if (!$scope.report.AutolandSatisfactory && !$scope.report.AutolandUnsatisfactory && !report.ManualLanding) {
				$scope.report.AutolandReasonIsPractice = false;
				$scope.report.AutolandReasonIsLowVisibility = false;
			}
			reportChanged()
		};	

		
		function updateCatAutolandStatus() {
			if (!$scope.report.catApproachSatisfactory && !$scope.report.catApproachUnsatisfactory && !report.ManualLanding) {
				$scope.report.AutolandReasonIsPractice = false;
				$scope.report.AutolandReasonIsLowVisibility = false;
			}
			reportChanged()
		};	


        /**
         * Clear Remarks
         * @memberof ReportCtrl
         * @param {object} item Report s question
         */
		function clearRemarks(item) {
			// put preset comments
			if (item != null) {
				item.ItemValue =null;
				reportChanged(item);
			}
		}

  		/**
         * Enable Autofill Delays Button
         * @memberof ReportCtrl
         */
		function checkAutofillDelaysButton(){
			report.Sections.forEach(
				function(section){
					var filteredItems = section.Items.filter(
						function(item){
							return item.DelayCodes && item.DelayCodes.length > 0
						});
					if(filteredItems.length > 0  && $scope.flightDelays &&
						(($scope.flightDelays.DC9 != null && $scope.flightDelays.DC9 != 0)
						|| ($scope.flightDelays.DC93 != null && $scope.flightDelays.DC93 != 0))){
						$scope.enableAutofillDelaysButton = true;
						return;
					}
				}
			);
		}

  		/**
         * Auto Get Delays In Items
         * @memberof ReportCtrl
         */
		function autoGetDelaysInItems(){
			if($scope.flightDelays){
				report.Sections.forEach(
					function(section){
						var filteredItems = section.Items.filter(
							function(item){
								var getItem = false;
								if(item.DelayCodes && item.DelayCodes.length > 0){
									var itemDelayCodeList = item.DelayCodes.split(',');
									if(itemDelayCodeList.includes("9") || itemDelayCodeList.includes("93")){
										getItem = true;
									}
								}
								return getItem;
							});
						if(filteredItems.length > 0){
							filteredItems.forEach(
								function(item){
									item.DelayMinutes = GetDelayMinutes(item, $scope.flightDelays);
									if(item.DelayMinutes > 0){
										item.ItemHasValue = true;
										item.ItemValue = "Delay minutes have been added automatically.";
									}
								}
							)
						}
					}
				);
			}
			
			reportChanged();
			$scope.autoGetDelaysIsExecuted = true;
		}

		/**
         * update Sum Value Of Reported Delays (excepts 93 and 9 codes)
         * @memberof ReportCtrl
         */
		function updateSumValueOfReportedDelays(){
			if($scope.flightDelays){
				var sumDelays = 0;
				report.Sections.forEach(
					function(section){
						var filteredItems = section.Items.filter(
							function(item){
								var getItem = false;
								if(item.ItemHasValue == true && item.DelayCodes && item.DelayCodes.length > 0){
									var itemDelayCodeList = item.DelayCodes.split(',');
									if(!itemDelayCodeList.includes("9") && !itemDelayCodeList.includes("93")){
										getItem = true;
									}
								}
								return getItem;
							});
						if(filteredItems.length > 0){
							filteredItems.forEach(
								function(item){
									if(item.DelayMinutes){
										sumDelays = sumDelays + item.DelayMinutes;
									}
								}
							)
						}
					}
				);
				$scope.sumReportedDelay = sumDelays;
			}
		}

		/**
         * Get flight delays from local storage
         * @memberof ReportCtrl
         */
		function GetDelayMinutes (item, flightDelays){
			var itemDelayCodeList = item.DelayCodes.split(',');
			var dc9 = 0;
			var dc93= 0;
			if(flightDelays && itemDelayCodeList.includes("9")){
				dc9 = flightDelays.DC9;
			}
			if(flightDelays && itemDelayCodeList.includes("93")){
				dc93 = flightDelays.DC93;
			}

			// take the max value
			return dc9 > dc93 ? dc9 : dc93; 
		}


		/**
		 * increases delays minutes number 
		 * @memberof ReportCtrl
		 */
		function plusNumber(item) {
			// put preset comments
			if (item != null) {
				if(item.DelayMinutes != null){
					item.DelayMinutes++;
				}
				else{
					item.DelayMinutes = 1;
				}
				reportChanged(item);
			} 
		}
		/**
		 * decreases delays minutes number 
		 * @memberof ReportCtrl
		 */
		function minusNumber(item) {
			if (item != null) {
				if(item.DelayMinutes != null && item.DelayMinutes > 0){
					item.DelayMinutes--;
				}
				else{
					item.DelayMinutes = 0;
				}
				reportChanged(item);
			}
		}

		/**
		 * Clear delays minutes number 
		 * @memberof ReportCtrl
		 */
		function clearNumber(item) {
			item.DelayMinutes = null;
			reportChanged(item);
		}

		

		function autoAdjustRun(){
			var t=$scope.autoAdjustTarget;
			t.style.overflow = 'hidden';
			t.style.height = 0;
			t.style.height = t.scrollHeight + 'px';
			if (t.style.height < 40) t.style.height=40;
			$scope.autoAdjustTarget = null;
			$scope.autoAdjustTimer = null;
			
			// also, update the report and save it to a temp place
			report.updateTotals();
			if (report.Status != 'synched')
				report.saveReportAsTemp();		
		}

		function adjustTextarea($event) {
			//$event.keyCode = 13
			//performing adjusts using a timer, to minimize times it executes, and make it faster on ipad2
			if ($scope.autoAdjustTimer != null){
				clearTimeout($scope.autoAdjustTimer);
				//old object pending... execute its adjustment and then plan new object's adjustment
				if ($event.target != $scope.autoAdjustTarget){
					$scope.autoAdjustRun();
				}
			}
			$scope.autoAdjustTarget = $event.target;
			$scope.autoAdjustTimer = setTimeout($scope.autoAdjustRun,500);
		}

        /**
         * When the user types a value into a report item updates totals of the report
         * @memberof ReportCtrl
         */
		function reportItemValueChanged() {
		
			// update the report totals
			report.updateTotals();
		}

        /**
         * Go to calendar and reset report
         * @memberof ReportCtrl
         */
		function cancelClicked() {
			// delete the temp report
			PilotReportLocalEditFactory.deleteTempReport();
			
			// set editing page to none
			SettingsMain.setEditingPage(null);

			// go to dashboard
			$location.path("/");
		}
        
        /**
         * Save Completed and Go to calendar
         * @memberof ReportCtrl
         */
        function saveClicked() {
			// save the report
			report.Status = 'completed';
			report.saveReport();
			FlightFactory.updateFlightFromReport(report);
			// delete the temp report
			PilotReportLocalEditFactory.deleteTempReport();
			
			//set editing page to none
			SettingsMain.setEditingPage(null);
				
			infoSaveOperation(report.Status);
            
			// go to flight info
            $location.path('/flightinfo/'+ report.FlightId);
		}
        
        /**
         * Save Draft
         * @memberof ReportCtrl
         */
        function saveDraftClicked() {
			
			// save the report
			report.Status = 'draft';
			report.saveReport();
			FlightFactory.updateFlightFromReport(report);
			// delete the temp report
			PilotReportLocalEditFactory.deleteTempReport();
			
			// set editing page to none
			SettingsMain.setEditingPage(null);
			
			infoSaveOperation(report.Status);
			// go to dashboard
			//$location.path("/");
		}

		function setCategory(category,section){
			 console.log(category);
			 var newCategoryFilters =[];
			 for (var i=0;i<categoryFilters.length;i++){
					 if(categoryFilters[i].section==section){
							 categoryFilters[i]={category:category ,section :section} ;
					 }
					 newCategoryFilters.push(categoryFilters[i]);
			 }
			 categoryFilters=newCategoryFilters;
			 $scope.categoryfilters=categoryFilters;
		}

        /**
         * Save Draft
         * @memberof ReportCtrl
         */
		function deleteReportClicked() {
			var status = report.status;
			var title="Warning";
			if (status=='synched') {
				title="Attention";
			}
			
			bootbox.dialog({
				message: "Please confirm that you wish to permanently reset this CP Flight Log.",
				title: "<strong>"+title+"<strong>",
				buttons: {
					cancel: {
						label: "Cancel",
						className: "btn-default",
					},
					danger: {
						label: "Reset CP Flight Log",
						className: "btn-warning",
						callback: function() {
							//add code here to remove report from temp location and possibly from permanent location
							//TODO:
							PilotReportLocalEditFactory.deleteReport(report.ReportGuid);
							// delete the temp report
							PilotReportLocalEditFactory.deleteTempReport();
                            
                             FlightFactory.updateFlightFromReport(report);
							// set editing page to none
							SettingsMain.setEditingPage(null);
							//next code moves user to main page
							$timeout(function(){
                               if($location.path()=="/report/temp"){
                                 $scope.openReport();
                               }else{
                                 $route.reload();
                               }})
						}
					}
				}
			});
		}
        
        /**
         * Show information about the save action
         * @memberof ReportCtrl
         * @param {string} state The action of the save completed or draft or discard
         */
		function infoSaveOperation(state){
			if(state=='completed'){
					$scope.infosaveactiontype = state;
					$scope.infosaveaction = true;
			}else if(state=='draft'){
					$scope.infosaveactiontype = state;
					$scope.infosaveaction = true
			}else if(state=='discard'){
					$scope.infosaveactiontype = state;
					$scope.infosaveaction = true
			}
			
			$timeout(function(){
					 $scope.infosaveaction = false;
			},5000);
		}

		function discard(){
			if (report==null){
				report = PilotReportLocalEditFactory.getPilotReportLocalEditForFlight(flightId);
			}
			var guid = report.ReportGuid;
			var status = report.Status;

			// delete the temp report
			PilotReportLocalEditFactory.deleteTempReport();

			//reuse guid if this was a new report
			if (status == 'pending')
				ReportGuidFactory.restoreGuid(report.ReportGuid);      
				
			// new / edit existing / load from temp
			if (reportId.startsWith('new:')) {
				var flightId = $routeParams.flightId; 
				// create a new report
				var newLocalReport = PilotReportLocalEditCreatorFactory.createNewLocalReportForFlight(flightId);

				if (newLocalReport == null) {
					bootbox.alert("<h4>Attention</h4>Unable to create a new log!<br/>Available pool of resources has been depleted and you need to synchronize with the server to renew it.",
						function() {
							$location.path("/");
							$scope.$apply();
						}
					);
				} else {
					// load the new report
					report = newLocalReport;
				}
			} else if (reportId == 'temp') {
				// load the report from the temp place
				report = PilotReportLocalEditFactory.getPilotReportLocalEditFromTemp();

				if (report == null && status!='pending') {
					// since we could not load the temp report, delete it
					PilotReportLocalEditFactory.deleteTempReport();

					bootbox.alert("<h4>Warning</h4>Unable to load temporary log.<br/>No temporary log found in this device or the report was corrupted",
						function() {
							$location.path("/");
							$scope.$apply();
						}
					)
				}
				if (report==null) { 
					report = PilotReportLocalEditCreatorFactory.createNewLocalReportForFlight($scope.flight.FlightId);
				}
			} else {
				// load the report
				report = PilotReportLocalEditFactory.getPilotReportLocalEdit(reportId);
				if (report == null) {
					bootbox.alert("<h4>Warning</h4>Unable to load the requested log.<br/>This entry does not exist in this device, our its data are corrupted and the entry is unusable.",
						function() {
							$location.path("/");
							$scope.$apply();
						}
					)
				}
			}
				
			$scope.report = report;
			infoSaveOperation('discard');
		}


		function validationWorkOrderNo(){
			if(!isNaN(+report.AutolandWorkOrderNo) && (report.AutolandWorkOrderNo.length >= 6 && report.AutolandWorkOrderNo.length <= 10)){
				report.AutolandWorkOrderNoIsValid = true;
				report.updateTotals();
				if (report.Status != 'synched')
				report.saveReportAsTemp();
			}
			else{
				report.AutolandWorkOrderNoIsValid = false;
				report.IsValid = false;
			}
		}


		 /**
         * update ACU Provision Value
         * @memberof ReportCtrl
         */
		function updateACUProvisionValue(selectedValue){
			report.ACUProvision.values = {
				Yes: false,
				No: false,
				Delayed: false,
				NotRequired: false,
				Faulty: false
			}
			
			report.ACUProvision.values[selectedValue] = true;
			report.ACUProvision.value = selectedValue;
			report.updateTotals();
		}

		/**
         * clear ACU Provision Remarks
         * @memberof ReportCtrl
         */
		function clearACUProvisionRemarks(){
			if (report.ACUProvision.remarks != null) {
				report.ACUProvision.remarks = null;
				report.updateTotals();
			}
		}

		/**
         * update ACU Provision Remarks - using debounce: ng-model-options="{ debounce: 1200 }" ng-change="updateACUProvisionRemarks()"
         * @memberof ReportCtrl
         */
		function updateACUProvisionRemarks(){
			report.updateTotals();
		}

		/**
		 * increases acu delays minutes number 
		 * @memberof ReportCtrl
		 */
		function plusACUMinutes() {
			if (report.ACUProvision != null) {
				if(report.ACUProvision.delayMinutes != null){
					report.ACUProvision.delayMinutes++;
				}
				else{
					report.ACUProvision.delayMinutes = 1;
				}
				reportChanged();
			} 
		}
		/**
		 * decreases acu delays minutes number 
		 * @memberof ReportCtrl
		 */
		function minusACUMinutes() {
			if (report.ACUProvision != null) {
				if(report.ACUProvision.delayMinutes != null && report.ACUProvision.delayMinutes > 0){
					report.ACUProvision.delayMinutes--;
				}
				else{
					report.ACUProvision.delayMinutes = 0;
				}
				reportChanged();
			}
		}

		/**
		 * Clear acu delays minutes number 
		 * @memberof ReportCtrl
		 */
		function clearACUMinutes() {
			report.ACUProvision.delayMinutes = null;
			reportChanged();
		}

};

 
 })();   